import SurveyActionTypes from "./survey.types";

//ACTION CREATORS

export const changeStatusSlack = (payload) => ({
    type: SurveyActionTypes.CHANGE_STATUS_SLACK,
    payload,
});

export const addNewSurveySlack = (payload) => ({
    type: SurveyActionTypes.ADD_NEW_SURVEY_SLACK,
    payload,
});

export const addNewQuestionSlack = (payload) => ({
    type: SurveyActionTypes.ADD_NEW_QUESTION_SLACK,
    payload,
});

export const addNewAnswerSlack = (payload) => ({
    type: SurveyActionTypes.ADD_NEW_ANSWER_SLACK,
    payload,
});

export const getSingleSurveyWithQandASlack = (payload) => ({
    type: SurveyActionTypes.GET_SINGLE_SURVEY_WITH_QUESTIONS_AND_ANSWERS_SLACK,
    payload,
});

export const addJSONCardtoSurveySlack = (payload) => ({
    type: SurveyActionTypes.ADD_JSON_CARD_TO_SURVEY_SLACK,
    payload,
});

export const getAllSurveysSlack = (payload) => ({
    type: SurveyActionTypes.GET_ALL_SURVEYS_SLACK,
    payload,
});

export const addJSONtoSurveySlack = (payload) => ({
    type: SurveyActionTypes.ADD_JSON_TO_SURVEY_SLACK,
    payload,
});

export const addScheduleSlack = (payload) => ({
    type: SurveyActionTypes.ADD_SCHEDULE_SLACK,
    payload,
});

export const getAllSurveysWithScheduleSlack = (payload) => ({
    type: SurveyActionTypes.GET_ALL_SURVEYS_WITH_SCHEDULE_SLACK,
    payload,
})

export const deleteScheduleSlack = (payload) => ({
    type: SurveyActionTypes.DELETE_SCHEDULE_SLACK,
    payload
});

export const getSingleSurveySlack = (payload) => ({
    type: SurveyActionTypes.GET_SINGLE_SURVEY_SLACK,
    payload
});

export const addNewResponseSlack = (payload) => ({
    type: SurveyActionTypes.ADD_NEW_RESPONSE_SLACK,
    payload
});

export const getAllQuestionsBySurveyIdSlack = (payload) => ({
    type: SurveyActionTypes.GET_ALL_QUESTIONS_BY_SURVEY_ID_SLACK,
    payload
});

export const deleteSurveySlack = (payload) => ({
    type: SurveyActionTypes.DELETE_SURVEY_SLACK,
    payload
});

export const getAllTemplatesSlack = (payload) => ({
    type: SurveyActionTypes.GET_ALL_TEMPLATES_SLACK,
    payload,
});

export const getSingleTemplateSlack = (payload) => ({
    type: SurveyActionTypes.GET_SINGLE_TEMPLATE_SLACK,
    payload
});

export const updateJsonBlockSlack = (payload) => ({
    type: SurveyActionTypes.UPDATED_JSON_BLOCK,
    payload
});
